import React from 'react'
import SocialItem from './item.js'
import styles from './index.module.scss'

function Social ({list}) {
    return (
        <ul className={`social lx-flex ${styles.social}`}>
            <SocialItem list={list}></SocialItem>
        </ul>
    )
}

export default Social;